<template>
  <div class="my_comb_animation">
    <ul class="animation_list">
      <li
        class="animation_item"
        v-for="(item, index) in combAnimationList"
        :key="index"
        :data-active="index === activeIndex"
        @click="change_item(index)"
      >
        <div class="animation_img">
          <div v-if="index === 0" class="type_img">{{$t('view_left_sidebar_page_setting_full_page_setting_258')}}</div>
          <div v-else class="type_img" :class="`type_img_${index}`"></div>
          <span class="active-icon el-icon-check"></span>
        </div>
        <div class="animation_title">{{ item.typeTitle }}</div>
      </li>
    </ul>
    <div class="animation_setting">
      <template v-if="setting_isShow">
        <div class="setting_item setting_radio" v-if="combAnimationList[activeIndex].trigger">
          <span class="setting_title">{{$t('widgets_basic_classification_edit_461')}}</span>
          <div class="setting_content">
            <el-radio-group v-model="combAnimationList[activeIndex].formData.trigger">
              <el-radio
                :label="index"
                v-for="(item, index) in combAnimationList[activeIndex].trigger"
                :key="index"
              >{{$t(item)}}</el-radio>
            </el-radio-group>
          </div>
        </div>
      </template>

      <div class="setting_item setting_radio" v-if="combAnimationList[activeIndex].direction">
        <span class="setting_title">{{$t('components_my_animation_my_comb_animation_2289')}}</span>
        <div class="setting_content">
          <el-radio-group v-model="combAnimationList[activeIndex].formData.direction">
            <el-radio
              :label="key"
              v-for="(item, key) in combAnimationList[activeIndex].direction"
              :key="key"
            >{{$t(item)}}</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import combAnimationList from "@/components/my_animation/comb_animation_list";
import Cookies from "js-cookie";
export default {
  name: "my_comb_animation",
  props: {
    defalutActive: {
      type: Number,
      default: 0
    },
    defaultFormData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    combAnimationList: {
      handler(val) {
        if (this.is_first) {
          this.is_first = false;
          return;
        }
        this.$emit("change", {
          typeTitle: val[this.activeIndex].typeTitle,
          id: val[this.activeIndex].id,
          formData: val[this.activeIndex].formData
        });
      },
      deep: true
    },
    activeIndex(val) {
      this.$emit("change", {
        typeTitle: this.combAnimationList[val].typeTitle,
        id: this.combAnimationList[val].id,
        formData: this.combAnimationList[val].formData
      });
    }
  },
  data() {
    return {
      combAnimationList: JSON.parse(JSON.stringify(combAnimationList)),
      activeIndex: this.defalutActive,
      is_first: true
    };
  },
  mounted() {
    if (this.defaultFormData) {
      this.combAnimationList[this.activeIndex].formData = this.defaultFormData;
    }
    // this.$emit('change', { typeTitle: this.combAnimationList[this.activeIndex].typeTitle, id: this.combAnimationList[this.activeIndex].id, formData: this.combAnimationList[this.activeIndex].formData })
  },
  methods: {
    change_item(index) {
      this.activeIndex = index;
    }
  },
  computed:{
    setting_isShow(){
      const is_god = Cookies.get('is_god_wm');
      const name = this.$store.state.app.module_Data.name;
      const modules = ['basic_banner','basic_nleavemessage','basic_rich_text']
      if(is_god){
        return true
      }
      else{
        if(modules.indexOf(name) > -1){
          return false
        }
        else{
          return true
        }
      }
    }

  }
};
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";
.my_comb_animation {
  .animation_list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 22px;
    .animation_item {
      margin: 7px 0;
      .animation_img {
        position: relative;
        margin: 0 3px;
        width: 76px;
        height: 76px;
        border: 1px solid #e1e1e1;
        .active-icon {
          display: none;
          width: 18px;
          height: 16px;
          color: #fff;
          position: absolute;
          bottom: 0;
          right: 0;
          background-color: #5874d8;
          line-height: 22px;
          font-size: 12px;
          padding: 0 3px;
          border-top-left-radius: 100%;
        }
        .type_img {
          width: 100%;
          height: 100%;
          line-height: 76px;
          text-align: center;
          background: url(~@/assets/image/cssSprite.png) no-repeat;
          &.type_img_1 {
            background-position: -48px -438px;
          }
          &.type_img_2 {
            background-position: -124px -438px;
          }
          &.type_img_3 {
            background-position: -200px -438px;
          }
          &.type_img_4 {
            background-position: -276px -438px;
          }
          &.type_img_5 {
            background-position: -352px -438px;
          }
          &.type_img_6 {
            background-position: -428px -438px;
          }
          &.type_img_7 {
            background-position: -504px -438px;
          }
          &.type_img_8 {
            background-position: -580px -438px;
          }
          &.type_img_9 {
            background-position: -656px -438px;
          }
        }
        &:hover {
          border-color: $theme-primary;
        }
      }
      .animation_title {
        text-align: center;
        cursor: pointer;
      }
      &[data-active] {
        .animation_img {
          border-color: $theme-primary;
          .active-icon {
            display: block;
          }
        }
      }
    }
  }
  .animation_setting {
    border-top: 1px dashed #def0ff;
    padding-top: 30px;
    .setting_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .setting_title {
        display: inline-block;
        // width: 50px;
        width: auto;
        text-align: right;
        vertical-align: middle;
        font-size: 13px;
        line-height: 1;
      }
      .setting_content {
        flex: 1;
        margin-left: 8px;
      }
      &.setting_radio {
        align-items: flex-start;
        min-height: 40px;
        .setting_content {
          display: inline-block;
          /deep/ .el-radio {
            margin: 0 15px 15px 0;
          }
        }
        &.setting_trigger {
          align-items: center;
          margin-bottom: 15px;
          .setting_content {
            /deep/ .el-radio {
              margin: 0 15px 0 0;
            }
          }
        }
      }
      &.setting_slider {
        .setting_title {
          margin-bottom: 8px;
        }
        .setting_content {
          flex: 0 0 220px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          /deep/ .my_slider_layer {
            .module {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_animation/my_comb_animation.vue